import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

export interface BookingIconProps {
  type: string;
}

function BookingIcon(props: BookingIconProps) { 
  switch (props.type) {
    case "Time":
      return <AccessTimeIcon color="primary" />;
    case "Booking Type":
      return <EventNoteOutlinedIcon color="primary" />;
    case "Branch Name":
      return <AccountBalanceOutlinedIcon color="primary" />;
    case "Region":
      return <LocationOnOutlinedIcon color="primary" />;
    default: {
      return <HelpOutlineOutlinedIcon color="primary" />;
    }
  }
};

export default BookingIcon;